import { ToggleButtonGroup, ToggleButton } from '@mui/material'
import PropTypes from 'prop-types'

const FieldToggleGroupComponent = ({ value, config={}, events={} }) => {
    const handleChange = (e, val) => {
        if (val !== null && events.handleChange)
            events.handleChange(val)
    }

    return (
        <ToggleButtonGroup
            className="c-FieldToggleGroup"
            value={value}
            exclusive
            color="primary"
            onChange={handleChange}
        >
            {(config.options || []).map((opt) => (
                <ToggleButton key={opt.value} value={opt.value}>{opt.label}</ToggleButton>
            ))}
        </ToggleButtonGroup>
    )
}

FieldToggleGroupComponent.propTypes = {
    value: PropTypes.any,

    config: PropTypes.shape({
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any,
            label: PropTypes.string
        }))
    }),

    events: PropTypes.shape({
        handleChange: PropTypes.func
    })
}

export { FieldToggleGroupComponent }
